import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type AppLanguage = 'pl' | 'en' | 'es';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly storageKey = 'app_language';
  private readonly defaultLanguage: AppLanguage = 'pl';

  constructor(private translate: TranslateService) {}

  init(userLanguage?: string): void {
    const savedLanguage = localStorage.getItem(this.storageKey);

    // Swiadomy wybor z selektora (zapisany w TEJ przegladarce) wygrywa z
    // jezykiem konta. Wczesniej bylo odwrotnie i jezyk konta nadpisywal wybor
    // przy kazdym logowaniu (regres Fernandy 10.08: ES wracal do PL).
    const language = savedLanguage || userLanguage || this.defaultLanguage;

    this.setLanguage(language.toLowerCase());
  }

  setLanguage(language: string): void {
    const lang = language.toLowerCase();

    this.translate.setDefaultLang('pl');
    this.translate.use(lang);

    localStorage.setItem(this.storageKey, lang);
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || this.defaultLanguage;
  }
}
